// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-workorder-report-serch-upload-button {
    font-size: 18px;
    background-color: #ffffff;
    /* width: 100%; */
    color: black;
    padding: 15px;
    border: 1px solid #C4C4C4;
    border-radius: 10px;
    box-shadow: none;
    display:flex;
    justify-content: space-between;
    grid-template-columns: 1fr;
}

.upload-report-search-group-section {
    width: 100%;
}

.upload-report-header-search-group-row-section {
    grid-template-columns: 3fr !important;
}

.upload-report-serch-item-section .react-date-picker__calendar{
    z-index: 4 !important;
}

.upload-report-serch-item-section .react-date-picker__calendar{
    z-index: 4 !important;
}
.upload-report-search-group-section .upload-report-serch-item-section:first-child,
.upload-report-search-group-section .upload-report-serch-item-section:nth-child(2) {
    display: grid;
    column-gap: 10px;
    grid-template-columns: 6fr 1fr 6fr 6fr 1fr;
    row-gap: 10px;
}

.upload-report-serch-item-section .label {
    display: flex;
    justify-content: center;
    align-items: center;
}

.view-report-search-group-section {
    width: 100%;
}

.view-report-header-search-group-row-section {
    grid-template-columns: 3fr !important;
}

.view-report-serch-item-section .react-date-picker__calendar{
    z-index: 4 !important;
}

.view-report-serch-item-section .react-date-picker__calendar{
    z-index: 4 !important;
}
.view-report-search-group-section .view-report-serch-item-section:first-child,
.view-report-search-group-section .view-report-serch-item-section:nth-child(2) {
    display: grid;
    column-gap: 10px;
    grid-template-columns: 6fr 1fr;
    row-gap: 10px;
}

.view-report-serch-item-section .label {
    display: flex;
    justify-content: center;
    align-items: center;
}
.view-card-section{
     /* background-color: #ffffff; */
    padding: 8px 20px 0px 20px;
}
.viewSearch-card-section {
    min-height: 62px;
    width: 100%;
    background: var(--neutral-color1) 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 6px var(--border-shadow-color2);
    border-radius: 6px;
    padding: 9px 14px 9px 24px;
    transition: all 0.5s;
    color: var(--indicators-green);
    border-left: 6px solid var(--indicators-green);
}

.viewSearch-card-section:hover {
    transform: scale(1.012);
    transition: all 0.5s;
    border: 1px solid var(--call-to-action1);
    border-left: 5px solid var(--indicators-green);
}

.wrapper-view-card-section {
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr 5fr;
    grid-column-gap: 20px;
    align-items: center;
   
}

.wrapper-view-card-section .normal-card-item-section {
    height: 100%;
    display: grid;
    align-items: flex-start;
    padding: 5px;
}
.wrapper-view-card-section.status-green::before,
.wrapper-view-card-section.card-view.status-green .normal-card-item-section:first-child::before
 {
    background: var(--indicators-green) 0% 0% no-repeat padding-box;
    
}

.wrapper-view-card-section .normal-card-item-section:first-child {
    border-right: 1px solid var(--neutral-color3);
   
}

.wrapper-view-card-section .normal-card-item-section:first-child .card-item-value {
    font: normal normal bold 18px/22px Lato;
    letter-spacing: 0.18px;
     color: var(--call-to-action1); 
}

.wrapper-view-card-section .normal-card-item-section:nth-child(2) {
    display: grid;
    grid-template-columns: repeat(3, 1fr) 0.1fr;
    grid-column-gap: 10px;
    align-items: flex-start;
   
}

.wrapper-view-card-section .normal-card-item-section:last-child {
    transition: all 1s;
    /* padding: 5px; */
}

.wrapper-view-card-section .normal-card-item-section .card-item-group {
    cursor: default;
}

/* --------- Mobile Design ----------- */

 @media screen and (max-width:992px) {

    .view-report-search-group-section .view-report-serch-item-section:first-child,
    .view-report-search-group-section .view-report-serch-item-section:nth-child(2) {
        display: flex;
        flex-direction: column;
    }

    .upload-report-search-group-section .upload-report-serch-item-section:first-child,
    .upload-report-search-group-section .upload-report-serch-item-section:nth-child(2) {
        display: flex;
        flex-direction: column;

    }

    .wrapper-view-card-section {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: start;

    }

    .wrapper-view-card-section .normal-card-item-section:first-child {
        border-right: none;
    }

    .wrapper-view-card-section .normal-card-item-section:nth-child(2) {
        display: flex;
        flex-direction: column;
    }

    .view-workorder-report-serch-upload-button {
        font-size: 9px;
    }

}
`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/PartnerUpload.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;AACA;;IAEI,aAAa;IACb,gBAAgB;IAChB,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;KACK,+BAA+B;IAChC,0BAA0B;AAC9B;AACA;IACI,gBAAgB;IAChB,WAAW;IACX,6DAA6D;IAC7D,mDAAmD;IACnD,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,8BAA8B;IAC9B,8CAA8C;AAClD;;AAEA;IACI,uBAAuB;IACvB,oBAAoB;IACpB,wCAAwC;IACxC,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,YAAY;AAChB;AACA;;;IAGI,+DAA+D;;AAEnE;;AAEA;IACI,6CAA6C;;AAEjD;;AAEA;IACI,uCAAuC;IACvC,sBAAsB;KACrB,6BAA6B;AAClC;;AAEA;IACI,aAAa;IACb,2CAA2C;IAC3C,qBAAqB;IACrB,uBAAuB;;AAE3B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,wCAAwC;;CAEvC;;IAEG;;QAEI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;;QAEI,aAAa;QACb,sBAAsB;;IAE1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,kBAAkB;;IAEtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;AAEJ","sourcesContent":[".view-workorder-report-serch-upload-button {\r\n    font-size: 18px;\r\n    background-color: #ffffff;\r\n    /* width: 100%; */\r\n    color: black;\r\n    padding: 15px;\r\n    border: 1px solid #C4C4C4;\r\n    border-radius: 10px;\r\n    box-shadow: none;\r\n    display:flex;\r\n    justify-content: space-between;\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.upload-report-search-group-section {\r\n    width: 100%;\r\n}\r\n\r\n.upload-report-header-search-group-row-section {\r\n    grid-template-columns: 3fr !important;\r\n}\r\n\r\n.upload-report-serch-item-section .react-date-picker__calendar{\r\n    z-index: 4 !important;\r\n}\r\n\r\n.upload-report-serch-item-section .react-date-picker__calendar{\r\n    z-index: 4 !important;\r\n}\r\n.upload-report-search-group-section .upload-report-serch-item-section:first-child,\r\n.upload-report-search-group-section .upload-report-serch-item-section:nth-child(2) {\r\n    display: grid;\r\n    column-gap: 10px;\r\n    grid-template-columns: 6fr 1fr 6fr 6fr 1fr;\r\n    row-gap: 10px;\r\n}\r\n\r\n.upload-report-serch-item-section .label {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.view-report-search-group-section {\r\n    width: 100%;\r\n}\r\n\r\n.view-report-header-search-group-row-section {\r\n    grid-template-columns: 3fr !important;\r\n}\r\n\r\n.view-report-serch-item-section .react-date-picker__calendar{\r\n    z-index: 4 !important;\r\n}\r\n\r\n.view-report-serch-item-section .react-date-picker__calendar{\r\n    z-index: 4 !important;\r\n}\r\n.view-report-search-group-section .view-report-serch-item-section:first-child,\r\n.view-report-search-group-section .view-report-serch-item-section:nth-child(2) {\r\n    display: grid;\r\n    column-gap: 10px;\r\n    grid-template-columns: 6fr 1fr;\r\n    row-gap: 10px;\r\n}\r\n\r\n.view-report-serch-item-section .label {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.view-card-section{\r\n     /* background-color: #ffffff; */\r\n    padding: 8px 20px 0px 20px;\r\n}\r\n.viewSearch-card-section {\r\n    min-height: 62px;\r\n    width: 100%;\r\n    background: var(--neutral-color1) 0% 0% no-repeat padding-box;\r\n    box-shadow: 0px 0px 6px var(--border-shadow-color2);\r\n    border-radius: 6px;\r\n    padding: 9px 14px 9px 24px;\r\n    transition: all 0.5s;\r\n    color: var(--indicators-green);\r\n    border-left: 6px solid var(--indicators-green);\r\n}\r\n\r\n.viewSearch-card-section:hover {\r\n    transform: scale(1.012);\r\n    transition: all 0.5s;\r\n    border: 1px solid var(--call-to-action1);\r\n    border-left: 5px solid var(--indicators-green);\r\n}\r\n\r\n.wrapper-view-card-section {\r\n    width: 100%;\r\n    height: 100%;\r\n    display: grid;\r\n    grid-template-columns: 1fr 5fr;\r\n    grid-column-gap: 20px;\r\n    align-items: center;\r\n   \r\n}\r\n\r\n.wrapper-view-card-section .normal-card-item-section {\r\n    height: 100%;\r\n    display: grid;\r\n    align-items: flex-start;\r\n    padding: 5px;\r\n}\r\n.wrapper-view-card-section.status-green::before,\r\n.wrapper-view-card-section.card-view.status-green .normal-card-item-section:first-child::before\r\n {\r\n    background: var(--indicators-green) 0% 0% no-repeat padding-box;\r\n    \r\n}\r\n\r\n.wrapper-view-card-section .normal-card-item-section:first-child {\r\n    border-right: 1px solid var(--neutral-color3);\r\n   \r\n}\r\n\r\n.wrapper-view-card-section .normal-card-item-section:first-child .card-item-value {\r\n    font: normal normal bold 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n     color: var(--call-to-action1); \r\n}\r\n\r\n.wrapper-view-card-section .normal-card-item-section:nth-child(2) {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr) 0.1fr;\r\n    grid-column-gap: 10px;\r\n    align-items: flex-start;\r\n   \r\n}\r\n\r\n.wrapper-view-card-section .normal-card-item-section:last-child {\r\n    transition: all 1s;\r\n    /* padding: 5px; */\r\n}\r\n\r\n.wrapper-view-card-section .normal-card-item-section .card-item-group {\r\n    cursor: default;\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n\r\n @media screen and (max-width:992px) {\r\n\r\n    .view-report-search-group-section .view-report-serch-item-section:first-child,\r\n    .view-report-search-group-section .view-report-serch-item-section:nth-child(2) {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .upload-report-search-group-section .upload-report-serch-item-section:first-child,\r\n    .upload-report-search-group-section .upload-report-serch-item-section:nth-child(2) {\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n    }\r\n\r\n    .wrapper-view-card-section {\r\n        width: 100%;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: start;\r\n\r\n    }\r\n\r\n    .wrapper-view-card-section .normal-card-item-section:first-child {\r\n        border-right: none;\r\n    }\r\n\r\n    .wrapper-view-card-section .normal-card-item-section:nth-child(2) {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .view-workorder-report-serch-upload-button {\r\n        font-size: 9px;\r\n    }\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
